"use client";

import { Toaster as Sonner } from "sonner";

import { cn } from "../lib/utils";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="system"
      position="top-right"
      expand={true}
      richColors={true}
      className="toaster group"
      toastOptions={{
        closeButton: true,
        classNames: {
          toast: cn(
            `group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg`,
            "[--success-bg:oklch(var(--foreground))] [--success-text:oklch(var(--success))] [--success-border:oklch(var(--border))]",
            "[--warning-bg:oklch(var(--foreground))] [--warning-text:oklch(var(--warning))] [--warning-border:oklch(var(--border))]",
            "[--error-bg:oklch(var(--foreground))] [--error-text:oklch(var(--error-foreground))] [--error-border:oklch(var(--border))]",
          ),
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
        duration: 5000,
      }}
      {...props}
    />
  );
};

export { Toaster };
